/* Field (mobile) action row: full-width, buttons share the width evenly and
   never overflow at 375px. Management uses <Space wrap> and is unaffected. */
.fieldRow {
  width: 100%;
}

/* Both an enabled <button> and AntD's disabled-tooltip <span> wrapper can be
   direct children here; give each an equal, shrinkable track so a two-button
   status splits ~50/50 and a single button fills the full width. */
.fieldRow > * {
  flex: 1 1 0;
  min-width: 0;
}

/* AntD wraps a disabled Button (kept for its explanatory tooltip) in an
   inline-block <span>; make it a flex track so the inner block Button fills
   its half and the split stays even. */
.fieldRow > span {
  display: flex;
}
